const apiConfig = {
    baseUrl: 'https://api.themoviedb.org/3/',
    apiKey: '9a95cee016dbc326f68a5f03afdf77a2',
    originalImage: (imgPath) => `https://image.tmdb.org/t/p/original/${imgPath}`,
    w500Image: (imgPath) => `https://image.tmdb.org/t/p/w500/${imgPath}`
}

export default apiConfig;